// ******************** CHECK EMAIL CONFIRMATION HASH ********************
export const CHECK_EMAIL_CONFIRMATION_HASH_LOADING =
	'CHECK_EMAIL_CONFIRMATION_HASH_LOADING';
export const CHECK_EMAIL_CONFIRMATION_HASH_SUCCESS =
	'CHECK_EMAIL_CONFIRMATION_HASH_SUCCESS';
export const CHECK_EMAIL_CONFIRMATION_HASH_ERROR =
	'CHECK_EMAIL_CONFIRMATION_HASH_ERROR';
